import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useSelector } from "react-redux";
import { resetPassword, selectLoading, selectResetEmailAddress } from "./components/ForgotPasswordPageSlice";
import { ForgotPasswordEmail } from "./components/ForgotPasswordEmail";
import { PasswordResetConfirmation } from "./components/PasswordResetConfirmation";

const initialValues = {
  email: "",
};

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("Wrong email format")
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Email is required"),
});

export function ForgotPasswordPage() {
  const navigate = useNavigate();
  const thunkDispatch = useThunkDispatch();
  const loading = useSelector(selectLoading);
  const resetEmailAddress = useSelector(selectResetEmailAddress);
  const { emailAddress } = useParams();

  return (
    <Formik
      initialValues={{ email: emailAddress ?? initialValues.email }}
      validationSchema={forgotPasswordSchema}
      onSubmit={(values) => {
        thunkDispatch(resetPassword(values.email));
      }}
    >
      {(formikProps) => (
        <Form>
          {/* begin::Heading */}
          <div className="text-center mb-10">
            <h1 className="heading-text cpl-text-primary mb-3">Forgot Your Password?</h1>
          </div>
          {resetEmailAddress === "" ? <ForgotPasswordEmail formikProps={formikProps} /> : <PasswordResetConfirmation />}
          {/* begin::Action */}
          <div className="text-center">
            {resetEmailAddress === "" ? (
              <>
                <button
                  type="submit"
                  id="kt_reset_password_submit"
                  className="cpl-btn btn-lg cpl-btn-primary w-100 mb-5"
                  disabled={loading}
                  data-test-id="forgot-password-form__submit-button"
                >
                  {loading ? (
                    <span className="indicator-progress" style={{ display: "block" }}>
                      Please wait...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  ) : (
                    <span className="indicator-label">Reset Password</span>
                  )}
                </button>
                <button
                  type="button"
                  className="cpl-btn btn-lg cpl-btn-secondary w-100 mb-5"
                  disabled={loading}
                  onClick={() => navigate(`/auth/login/${formikProps.values.email}`)}
                  data-test-id="forgot-password-form__cancel-link"
                >
                  <span className="indicator-label">Cancel</span>
                </button>
              </>
            ) : (
              <>
                <button
                  type="button"
                  className="cpl-btn btn-lg cpl-btn-primary w-100 mb-5"
                  onClick={() => navigate(`/auth/login/${formikProps.values.email}`)}
                  data-test-id="forgot-password-form__login-link"
                >
                  <span className="indicator-label">Login</span>
                </button>
                <button
                  type="button"
                  className="cpl-btn btn-lg cpl-btn-secondary w-100 mb-5"
                  onClick={() => navigate(`/auth/registration/${formikProps.values.email}`)}
                  data-test-id="forgot-password-form__register-link"
                >
                  <span className="indicator-label">Register</span>
                </button>
              </>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}
